import { render, staticRenderFns } from "./ReservationListPage.vue?vue&type=template&id=4beb1c47&"
import script from "./ReservationListPage.vue?vue&type=script&lang=js&"
export * from "./ReservationListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports